import { Component, OnInit, ViewChild } from '@angular/core';
import { Canal } from '../../_models/canal';
import { CanalService } from '../../_services/canal.service';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  selector: 'app-canales-listado',
  templateUrl: 'canales-listado.component.html'
} )

export class CanalesListadoComponent implements OnInit {

  canales: Canal[] = [];
  carCanales = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private canServicio: CanalService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private router: Router ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/canales' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CANALES.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CANALES.LBL_NOMBRE' ), sort: true },
      { field: 'nombreTipoCanal', header: this.navServicio.buscarMensaje( 'CANALES.LBL_TIPOCANAL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'CANALES.LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'canales.component' );

    this.canServicio.listadoCanales().subscribe( canales => {
      this.canales = canales;
      this.carCanales = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crearCanal(){
    this.router.navigate(['apl/canales/agregar']);
  }

  verCanal( canal: Canal ) {
    this.router.navigate( [ 'apl/canales/detalle/' + canal.idCanal ] );
  }

  editarCanal( canal: Canal ) {
    this.router.navigate( [ 'apl/canales/actualizar/' + canal.idCanal ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'canales.component', this.busqueda );
  }

}
